import React, { useState, useEffect, useRef, useCallback } from 'react';

const TextAnimation = ({ text }) => {
  const [animateText, setAnimateText] = useState('');
  const [index, setIndex] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const timeoutRef = useRef(null);

  const resetAnimation = useCallback(() => {
    setAnimateText('');
    setIndex(0);
    setIsCompleted(false);
  }, []);

  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!text || text.length === 0) {
      return;
    }

    if (index < text.length) {
      // Typing animation
      timeoutRef.current = setTimeout(() => {
        setAnimateText(text.slice(0, index + 1));
        setIndex(prev => prev + 1);
      }, 120);
    } else if (!isCompleted) {
      // Mark as completed and wait before restart - 10 second cycle
      setIsCompleted(true);
      timeoutRef.current = setTimeout(() => {
        resetAnimation();
      }, 10000); // 10 seconds wait before restart
    }

    // Cleanup function
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [index, text, isCompleted, resetAnimation]);

  // Alternative approach: Use setInterval for continuous looping
  useEffect(() => {
    const totalCycleTime = (text.length * 120) + 10000; // typing time + wait time
    
    const intervalId = setInterval(() => {
      resetAnimation();
    }, totalCycleTime);

    return () => {
      clearInterval(intervalId);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [text, resetAnimation]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <p className="text-3xl font-bold text-white" aria-live="polite">
      {animateText}
      <span className="animate-pulse">|</span>
    </p>
  );
};

export default TextAnimation;
